import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Research",
  "description": "",
  "published": "2007-01-18T00:00:00.000Z",
  "redirect_from": ["/blog/research/swizec/319"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Public entertainment like different sitcoms, films etc. usually do a lot of research on the theme their work revolves around. Thus somebody making a sitcom about ravers would do a lot of research about rave and its culture as would the actors and much anybody involved in the content. Most of the time the research does well and the mistakes are difficult to spot if not even unexistant.`}</p>
    <p>{`But then there are shows that simply leave a gaping hole in their characters and everyting going on. Such a show is`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/It_crowd"
      }}>{` The IT Crowd`}</a>{`. Don't get me wrong, it's an awesome show and one of the few that can actually make a viewer laugh as much as to Monty Python, at least anybody who's at least a bit into geekdom.`}</p>
    <p>{`In one of the episodes the two geeks are clearly shown using Internet Explorer 6. Sure, many people use it, but that the characters of their nature used it is just beyond comprehension. It's not like they missed out on some little detail, and it's not like the overall research was bad, I mean, they even have the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Flying_spaghetti_monster"
      }}>{`Flying Spaghetti Monster`}</a>{`. The large issue here is that the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Browser_war"
      }}>{`Browser War`}</a>{` has been going on since 1995 and that's quite a while ago, hell, that's older than Google. We can let go of the fact they're using windows because that's excusable when they're working for a large company in a lowly IT department, but IE is just beyond excusability. Somebody should write an angry letter to the creators of that show.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      